import React from "react";
import * as THREE from "three";

const Column3D = ({ column, gridScale = 1 }) => {
    console.log("Normal COlumn", column);
    const { x, y } = column.values.point;
    const outreach = column.values.outreach || 0;
    const height = column.values.height || 6;
    const radius = 0.2;
    const color = column.color === '#212529' ? "lightgray" : column.color;
    const positionAngle = column.values.positionAngle || 0;
    const tiltDeg = column.values.tilt ?? 0;

    const outreachWidth = 0.75 * outreach;
    const outreachHeight = 0.2;
    const outreachDepth = 0.2;

    const columnBaseZ = (height * gridScale) / 2;

    const topOfColumn = [
        x * gridScale,
        y * gridScale * -1,
        columnBaseZ + (height * gridScale) / 2 - 0.05,
    ];

    const angleRad = -(positionAngle - 90) * (Math.PI / 180);
    const direction = new THREE.Vector3(Math.cos(angleRad), Math.sin(angleRad), 0);

    const halfOutreachWidth = (outreachWidth * gridScale) / 2;
    const baseOffset = direction.clone().multiplyScalar(halfOutreachWidth);

    const tiltRad = (tiltDeg * Math.PI) / 180;

    let inwardOffset = Math.sin(tiltRad) * (outreachHeight * gridScale) / 2;
    let upwardOffset = Math.sin(tiltRad) * (outreachDepth * gridScale) / 2;

    if (tiltDeg < 0) {
        inwardOffset *= -1;
        upwardOffset *= -1;
    }
    const xRot = tiltRad;
    const yRot = 0;

    return (
        <>
            <mesh position={[x * gridScale, y * gridScale * -1, columnBaseZ]} rotation={[Math.PI / 2, 0, 0]}>
                <cylinderGeometry args={[radius * gridScale, radius * gridScale, height * gridScale, 32]} />
                <meshStandardMaterial color={color} />
            </mesh>

            <mesh
                position={[
                    topOfColumn[0] + baseOffset.x - inwardOffset * direction.x,
                    topOfColumn[1] + baseOffset.y - inwardOffset * direction.y,
                    topOfColumn[2] - outreachHeight / 2 + upwardOffset,
                ]}
                rotation={[xRot, yRot, angleRad]}
            >
                <boxGeometry args={[outreachWidth * gridScale, outreachHeight * gridScale, outreachDepth * gridScale]} />
                <meshStandardMaterial color={color} />
            </mesh>
        </>
    );
};

export default Column3D;
